import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from 'react-router-dom';
import CompanyProductBox from '../components/companyProductBox';
import Swal from 'sweetalert2'

const MyProducts = () => {
  const [myProducts, setMyProducts] = useState();
  const [companyProducts, setCompanyProducts] = useState();
  const [activeCompany, setActiveCompany] = useState(); // Save to localStorage - to use in AddEditPage to retain after refresh
  const [userCompanies, setUserCompanies] = useState();
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const [selectedCompany, setSelectedCompany] = useState();

  const serverUrl = process.env.REACT_APP_SERVER_URL;
  useEffect(() => {
    setCompanyProducts(myProducts?.filter(x => x.companyName == activeCompany?.companyName));
  }, [myProducts, selectedCompany]);

  useEffect(() => {
    async function getMyProducts() {
      const token = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", token);

      const response = await fetch(`${serverUrl}/api/companyProducts`, { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });

      const myProducts = await response.json();

      setMyProducts(myProducts);
    }
    async function getUserCompanies() {
      const token = await getAccessTokenSilently();
      localStorage.setItem("AcccessToken", token);

      const response = await fetch(`${serverUrl}/api/user`, { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });

      const dbUser = await response.json();
      setUserCompanies(dbUser.userCompanies);

      try { // Save to localStorage - to use in AddEditPage to retain after refresh
        let localData = localStorage.getItem('selectedCompany');
        let activeCompany = JSON.parse(localStorage.getItem('selectedCompany'));
        if (!dbUser.userCompanies.find(x => x.companyName == activeCompany.companyName)) {
          setActiveCompany(dbUser.userCompanies[0]);
          setSelectedCompany(dbUser.userCompanies[0].companyName);
        }
        else {
          setActiveCompany(activeCompany);
          setSelectedCompany(activeCompany.companyName);
        }
        // if (!localData) {
        //   localStorage.setItem('selectedCompany', JSON.stringify(dbUser.userCompanies[0]));
        //   setActiveCompany(dbUser.userCompanies[0]);
        //   setSelectedCompany(dbUser.userCompanies[0].companyName);
        // }
        // else {
        //   let activeCompany = JSON.parse(localStorage.getItem('selectedCompany'));
        //   if (dbUser.userCompanies.find(x => x.companyName == activeCompany.companyName)) {
        //     setSelectedCompany(activeCompany.companyName);
        //     setActiveCompany(activeCompany);
        //   } else {
        //     //Check if saved company is not part of user companies because of new session. It will reset to right value.
        //     localStorage.setItem('selectedCompany', JSON.stringify(dbUser.userCompanies[0]));
        //     setActiveCompany(dbUser.userCompanies[0]);
        //     setSelectedCompany(dbUser.userCompanies[0].companyName);
        //   }
        // }
      } catch {
        localStorage.setItem('selectedCompany', JSON.stringify(dbUser.userCompanies[0]));
        setActiveCompany(dbUser.userCompanies[0]);
        setSelectedCompany(dbUser.userCompanies[0].companyName);
      }
      //getAllProducts
      getMyProducts();

    }
    getUserCompanies();


  }, []);

  const goToSingleProductView = (idProduct) => {
    try {
      history.push(`/singleProductView/${idProduct}`);
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }
  };

  const goToAddProducts = (idProduct) => {
    try {
      history.push(`/addEditProduct`);
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }
  }

  const goToEditProduct = (idProduct) => {
    try {
      history.push(`/addEditProduct/${idProduct}`);
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }
  }
  const updateSelectedCompany = (companyName) => {
    setSelectedCompany(companyName);
    let selectedCompany = userCompanies.find(x => x.companyName === companyName);
    setActiveCompany(selectedCompany);
    localStorage.setItem('selectedCompany', JSON.stringify(selectedCompany));
  }

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-outline-warning",
      cancelButton: "btn btn-outline-warning"
    },
    buttonsStyling: false
  });

  return (
    <div className="container">
      <h1>Meine Produkte</h1>
      {/* <h6>Company: {activeCompany ? activeCompany.companyName : "Kein verknüpftes Unternehmen gefunden."}</h6> */}
      {userCompanies && userCompanies.length > 0 && <div className="form-group">
        <div className="row">
          <div className="col-3">
            <label htmlFor="category-select">Unternehmen auswählen:</label>
            <select
              id="company-select"
              className="form-control"
              value={selectedCompany}
              onChange={(e) => updateSelectedCompany(e.target.value)}
            >
              {userCompanies.map((company, index) => (
                <option key={index} value={company.companyName}>{company.companyName}</option>
              ))}
            </select>
          </div>
        </div>
      </div>}
      <hr />
      <p>
        Auf dieser Seite findest Du eine vollständige Übersicht aller Deinen Produkte, egal ob sie abgeschlossen, derzeit aktiv oder für einen späteren Zeitpunkt geplant sind. Dies ermöglicht Dir, den Fortschritt jedes Produktes genau zu verfolgen und Deine Planungen effektiv zu gestalten.
      </p>
      <hr />
      <div className="row mb-20">
        <div className="col-md-10"></div>
        <div className="col-sm-12">
          <button type="button" id={"addproduct"} className="btn btn-outline-warning float-right"
            block="true" onClick={() => goToAddProducts()}>
            {"Neues Produkt"} +
          </button>
        </div>
      </div>

      <div className="row">
        {companyProducts && companyProducts.length == 0 && <h4>Keine Ergebnisse gefunden.</h4>}

        {companyProducts && companyProducts.length > 0 && companyProducts.map(product => (
          <CompanyProductBox
            key={product.idProduct}
            product={product}
            button={
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <button
                  id={product.idProduct + "edit"}
                  className="btn btn-outline-warning col-md-6"
                  onClick={() => goToEditProduct(product.idProduct)}
                >
                  Bearbeiten
                </button>
                <button
                  id={product.idProduct + "view"}
                  className="btn btn-outline-warning col-md-6"
                  onClick={() => goToSingleProductView(product.idProduct)}
                >
                  Öffnen
                </button>
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default MyProducts;

